import { useEffect } from 'react';

import { useFilter } from '@features/table-filter';

import { useGetMethodsQuery } from '../api';
import type { IMethodFilter } from '../model/types';

interface IProps {
  merchantId?: string;
  currencyId?: string;
  midIds?: string;
  shouldFilterByCurrency?: boolean;

  disableUrlFilter?: boolean;
}

export const useMethods = ({
  merchantId,
  currencyId,
  midIds,
  disableUrlFilter,
  shouldFilterByCurrency = true,
}: IProps = {}) => {
  const filter = useFilter<IMethodFilter>({ disableUrlFilter });
  const { currentFilter, updateFilter } = filter;

  const {
    data: methods,
    isLoading,
    isError,
    error,
    isFetching,
    isSuccess,
    refetch,
  } = useGetMethodsQuery(currentFilter.toString());

  useEffect(() => {
    updateFilter({ 'filter[merchant_id]': merchantId });
  }, [merchantId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (shouldFilterByCurrency) {
      updateFilter({ 'filter[currency_id]': currencyId });
    }
  }, [currencyId, shouldFilterByCurrency]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    updateFilter({ 'filter[mid_ids]': midIds });
  }, [midIds]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    methods,
    isError,
    error,
    isLoading,
    isFetching,
    isSuccess,
    refetch,

    filter,
  };
};
